(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-upsell"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-upsell-toggle]');
  if (!btn) return;

  const card = btn.closest('.cart-upsell__card');
  if (!card) return;

  const isExpanded = card.classList.toggle('is-expanded');
  btn.textContent = isExpanded ? 'Show less' : 'Load more';
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["compare-slider"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-compare]').forEach((el) => {
    const overlay = el.querySelector('.compare__overlay');
    const slider = el.querySelector('.compare__slider');

    let isPointerDown = false;
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let frame = null;

    const THRESHOLD = 5;

    const setPosition = (clientX) => {
      const rect = el.getBoundingClientRect();
      let x = clientX - rect.left;

      x = Math.max(0, Math.min(x, rect.width));

      const percent = (x / rect.width) * 100;

      overlay.style.width = (100 - percent) + '%';
      slider.style.left = percent + '%';
      slider.setAttribute('aria-valuenow', Math.round(percent));
    };

    const update = (clientX) => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => setPosition(clientX));
    };

    const onPointerDown = (e) => {
      isPointerDown = true;
      isDragging = false;
      startX = e.clientX;
      startY = e.clientY;
      e.currentTarget.setPointerCapture(e.pointerId);
      overlay.style.transition = 'none';
      slider.style.transition = 'none';
    };

    const onPointerMove = (e) => {
      if (!isPointerDown) return;

      const dx = e.clientX - startX;
      const dy = e.clientY - startY;

      if (!isDragging) {
        if (Math.abs(dx) > THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
          isDragging = true;
        } else {
          return;
        }
      }

      e.preventDefault();
      update(e.clientX);
    };

    const onPointerUp = () => {
      isPointerDown = false;
      isDragging = false;
      overlay.style.transition = '';
      slider.style.transition = '';
    };

    el.addEventListener('pointerdown', onPointerDown);
    el.addEventListener('pointermove', onPointerMove);
    el.addEventListener('pointerup', onPointerUp);
    el.addEventListener('pointercancel', onPointerUp);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-compare-slider"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-compare]').forEach((el) => {
    const overlay = el.querySelector('.compare__overlay');
    const slider = el.querySelector('.compare__slider');

    let isPointerDown = false;
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let frame = null;

    const THRESHOLD = 5;

    const setPosition = (clientX) => {
      const rect = el.getBoundingClientRect();
      let x = clientX - rect.left;

      x = Math.max(0, Math.min(x, rect.width));

      const percent = (x / rect.width) * 100;

      overlay.style.width = (100 - percent) + '%';
      slider.style.left = percent + '%';
      slider.setAttribute('aria-valuenow', Math.round(percent));
    };

    const update = (clientX) => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => setPosition(clientX));
    };

    const onPointerDown = (e) => {
      isPointerDown = true;
      isDragging = false;
      startX = e.clientX;
      startY = e.clientY;
      e.currentTarget.setPointerCapture(e.pointerId);
      overlay.style.transition = 'none';
      slider.style.transition = 'none';
    };

    const onPointerMove = (e) => {
      if (!isPointerDown) return;

      const dx = e.clientX - startX;
      const dy = e.clientY - startY;

      if (!isDragging) {
        if (Math.abs(dx) > THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
          isDragging = true;
        } else {
          return;
        }
      }

      e.preventDefault();
      update(e.clientX);
    };

    const onPointerUp = () => {
      isPointerDown = false;
      isDragging = false;
      overlay.style.transition = '';
      slider.style.transition = '';
    };

    el.addEventListener('pointerdown', onPointerDown);
    el.addEventListener('pointermove', onPointerMove);
    el.addEventListener('pointerup', onPointerUp);
    el.addEventListener('pointercancel', onPointerUp);
  });
  } catch(e) { console.error(e); }
})();

})();
